{
  "manage": {
    "activity_titles": "Manage Activity Titles"
  },
  "user_menu": {
    "logged_in_as": "You are logged in as",
    "switch_account": "Switch Account",
    "updated_contacts": "Updated Contacts",
    "help": "Help",
    "individual_connect": "Individual Connect",
    "admin_connect": "Admin Connect ({{consentName}})"
  },
  "permission_section": {
    "contacts": "Contacts",
    "companies": "Companies",
    "prospects": "Prospects",
    "opportunities": "Opportunities",
    "objectives": "Objectives",
    "employee": "Employee",
    "workspaces_and_apps": "Workspaces and Apps",
    "marketing_lists": "Marketing Lists",
    "referral_tracking": "Referral Tracking",
    "interactions": "Interactions",
    "research_reports": "Research Reports"
  },
  "user_management": {
    "users": {
      "add_user": "Add User",
      "edit_user": "Edit User",
      "users_tab": "Users",
      "delegate_access": "Check Delegate Accesses of {{profileName}}",
      "delegate_account": "Delegate Account",
      "main_account": "Main Account"
    },
    "roles": {
      "add_role": "Add Role",
      "roles_tab": "Roles",
      "base_role": "Base Role",
      "individual_lawyer": "Individual Lawyer"
    },
    "forms": {
      "name": "Name",
      "email": "Email",
      "role": "Role",
      "description": "Description",
      "edit": "Edit {{profileName}}",
      "delete": "Delete {{delegateUserName}}",
      "select_role": "Select Role",
      "type_email": "Type email",
      "type_role_name": "Type Role Name",
      "describe_role": "Describe the Role"
    },
    "validation": {
      "please_select_role": "Please select a role",
      "please_enter_valid_email": "Please enter a valid email",
      "name_required": "Name is required"
    },
    "confirmations": {
      "delete_user_title": "Delete User",
      "delete_user_content": "Are you sure you want to delete this user? This action cannot be undone.",
      "delegate_access_caption": "Assign delegate user access to the main account."
    }
  },
  "access_role_permission_form": {
    "role_description": "Role Description - {{description}}"
  },
  "permissions": {
    "viewMyContacts": "View My Contacts",
    "exportMyContacts": "Export My Contacts",
    "viewAllContacts": "View All Contacts",
    "exportAllContacts": "Export All Contacts",
    "viewContactRecords": "View Contact Records",
    "viewContactWhoKnows": "View Contact Who Knows",
    "viewLastInteractionDateUser": "View Last Interaction Date User",
    "viewLastInteractionDateFirm": "View Last Interaction Date Firm",
    "viewContactEmailAddresses": "View Contact Email Addresses",
    "viewContactActivities": "View Contact Activities",
    "viewMyCompanies": "View My Companies",
    "exportMyCompanies": "Export My Companies",
    "viewAllCompanies": "View All Companies",
    "exportAllCompanies": "Export All Companies",
    "viewCompanyRecords": "View Company Records",
    "viewCompanyWhoKnows": "View Company Who Knows",
    "viewMyProspects": "View My Prospects",
    "viewAllProspects": "View All Prospects",
    "viewMyOpportunities": "View My Opportunities",
    "viewAllOpportunities": "View All Opportunities",
    "exportAllOpportunities": "Export All Opportunities",
    "viewMyObjectives": "View My Objectives",
    "viewAllObjectives": "View All Objectives",
    "viewEmployeeEngagementTab": "View Employee Engagement Tab",
    "viewEmployeeOpportunitiesTab": "View Employee Opportunities Tab",
    "exportCompanyLists": "Export Company Lists",
    "exportContactLists": "Export Contact Lists",
    "exportGenericLists": "Export Generic Lists",
    "exportKeyActivityLists": "Export Key Activity Lists",
    "exportOpportunities": "Export Opportunities",
    "exportAllActivities": "Export All Activities",
    "exportMarketingLists": "Export Marketing Lists",
    "exportReferrals": "Export Referrals",
    "readCompanyReport": "Read Company Report",
    "editCompanyReport": "Edit Company Report"
  },
  "access_role_page": {
    "user_management": "User Management"
  },
  "settings": {
    "language": "Language"
  },
  "delete_role": {
    "confirm_content": "Are you sure you want to delete this role? This action cannot be undone."
  },
  "access_role_table": {
    "role": "Role",
    "description": "Description"
  },
  "switch_account": {
    "select_user": "Select who you would like to log in as"
  },
  "account_colour": {
    "select_colour": "select account colour"
  },
  "callback": {
    "authenticated": "Authenticated!",
    "redirecting_message": "We are working on redirecting you to the right place..."
  }
}
